// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"AddPallet_buttonsFooter__33GAy"};